import React from 'react';
// import logo from '../../ve_logo.png';
import logo from './cloud_logo.png';

const Header = props => {

  return (
    <div style={styles.loginHeaderStyle}>
        <img
          src={logo}
          alt='logo'
          height={'50%'}
          width={'auto'}
          style={{ marginLeft: 20, textAlign: 'center' }} /> 
    </div>
  )
}

export default Header;

const styles = {
  loginHeaderStyle: {
    width: '100%', 
    height: '10vmin', 
    borderTopRightRadius: 5, 
    borderTopLeftRadius: 5, 
    backgroundColor: 'rgba(255,255,255,0.7)',
    display: 'flex', 
    alignItems: 'center', 
    justifyContent: 'center'
  },
};